import { translateString } from '@shared/utils/translateString';

export const translateDays = (arrayDay: string[]) => {
  return `Toda ${arrayDay.map((e) => translateString(e))}`;
};
